import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { IPost } from '../../types';

interface IProps {
	post: IPost;
}

const Default = ({ post }: IProps) => {
	const linkText = `View ${post.primary_term.name} ${post.primary_term.name !== 'Press Release' ? 'Post' : ''}`;

	return (
		<a className="pfa-card-default" href={post.permalink} data-theme="white">
			{post.primary_term.name && (
				<div className="pfa-card-default__tag-container">
					<p
						className="pfa-card-default__tag post-tag"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.primary_term.name) }}
					/>
				</div>
			)}
			<div className="pfa-card-default__content">
				{post.post_title && (
					<h3
						className="pfa-card-default__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
					/>
				)}
				{post.post_excerpt && (
					<p
						className="pfa-card-default__excerpt"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_excerpt) }}
					></p>
				)}
			</div>
			<div className="pfa-card-default__button-container">
				<div className="btn-tertiary btn-highlight pfa-card-default__button">
					{linkText}
				</div>
			</div>
		</a>
	);
};

Default.displayName = 'Default';

export default Default;
